interface IconSVGProps {
  fill?: string;
  stroke?: string;
  className?: string;
}

export const InfoSVG = ({ fill, stroke, className }: IconSVGProps) => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' fill={fill ? fill : 'none'} viewBox='0 0 24 24' strokeWidth='1.5' stroke={stroke ? stroke : 'currentColor'} className={className}>
      <path strokeLinecap='round' strokeLinejoin='round' d='M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z' />
    </svg>
  );
};

export const QuestionIcon = ({ fill, stroke, className }: IconSVGProps) => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' fill={fill ? fill : 'none'} viewBox='0 0 24 24' strokeWidth='1.5' stroke={stroke ? stroke : 'currentColor'} className={className}>
      <path
        strokeLinecap='round'
        strokeLinejoin='round'
        d='M9.879 7.519c1.171-1.025 3.071-1.025 4.242 0 1.172 1.025 1.172 2.687 0 3.712-.203.179-.43.326-.67.442-.745.361-1.45.999-1.45 1.827v.75M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9 5.25h.008v.008H12v-.008z'
      />
    </svg>
  );
};

export const LoadingIcon = ({ fill, stroke, className }: IconSVGProps) => {
  return (
    <svg
      aria-hidden='true'
      role='status'
      className={`inline w-4 h-4 me-3 text-white animate-spin ${className}`}
      viewBox='0 0 100 101'
      fill={fill ? fill : 'none'}
      xmlns='http://www.w3.org/2000/svg'
      stroke={stroke ? stroke : 'currentColor'}
    >
      <path
        d='M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z'
        fill='#E5E7EB'
      />
      <path
        d='M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z'
        fill='currentColor'
      />
    </svg>
  );
};

export const BigLoadingIcon = ({ fill, stroke, className }: IconSVGProps) => {
  return (
    <svg
      aria-hidden='true'
      role='status'
      className={`inline w-8 h-8 text-white animate-spin ${className}`}
      viewBox='0 0 100 101'
      fill={fill ? fill : 'none'}
      xmlns='http://www.w3.org/2000/svg'
      stroke={stroke ? stroke : 'currentColor'}
    >
      <path
        d='M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z'
        fill='#E5E7EB'
      />
      <path
        d='M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z'
        fill='currentColor'
      />
    </svg>
  );
};

export const MobileIcon = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' strokeWidth={1.5} stroke='currentColor' className='w-5 h-5'>
      <path
        strokeLinecap='round'
        strokeLinejoin='round'
        d='M10.5 1.5H8.25A2.25 2.25 0 006 3.75v16.5a2.25 2.25 0 002.25 2.25h7.5A2.25 2.25 0 0018 20.25V3.75a2.25 2.25 0 00-2.25-2.25H13.5m-3 0V3h3V1.5m-3 0h3m-3 18.75h3'
      />
    </svg>
  );
};

export const LocationIcon = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' strokeWidth={1.5} stroke='currentColor' className='w-5 h-5'>
      <path strokeLinecap='round' strokeLinejoin='round' d='M15 10.5a3 3 0 11-6 0 3 3 0 016 0z' />
      <path strokeLinecap='round' strokeLinejoin='round' d='M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z' />
    </svg>
  );
};

export const EmailIcon = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' strokeWidth={1.5} stroke='currentColor' className='w-5 h-5'>
      <path
        strokeLinecap='round'
        strokeLinejoin='round'
        d='M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75'
      />
    </svg>
  );
};

export const FacebookIcon = ({ iconColor }: { iconColor?: string }) => {
  const color = iconColor ? iconColor : '#000000';

  return (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M16.534 20.668C14.4007 21.0153 12.26 21.3356 10.112 21.629C12.2607 21.3356 14.4013 21.0153 16.534 20.668Z' fill='#2F3783' />
      <path d='M15.377 19.793C14.357 19.981 13.338 20.152 12.318 20.328C13.336 20.152 14.356 19.98 15.377 19.793Z' fill='#2F3783' />
      <path d='M16.592 22.3398C14.096 22.6212 11.587 22.8685 9.065 23.0818C11.5843 22.8712 14.0933 22.6238 16.592 22.3398Z' fill='#2F3783' />
      <path d='M15.099 21.7378C13.899 21.8978 12.693 22.0468 11.49 22.1868C12.692 22.0468 13.899 21.8998 15.099 21.7378Z' fill='#2F3783' />
      <path d='M15.526 18.4102C14.626 18.6012 13.726 18.7932 12.826 18.9762C13.725 18.7932 14.628 18.6002 15.526 18.4102Z' fill='#2F3783' />
      <path d='M16.068 17.8828C15.341 18.0898 14.615 18.2828 13.888 18.4878C14.615 18.2858 15.342 18.0898 16.068 17.8828Z' fill='#2F3783' />
      <path d='M15.914 18.728C15.125 18.935 14.332 19.146 13.539 19.345C14.3317 19.1457 15.1233 18.94 15.914 18.728Z' fill='#2F3783' />
      <path d='M15.679 18.8271C14.843 19.0271 13.999 19.2062 13.156 19.3932C13.999 19.2062 14.843 19.0221 15.679 18.8271Z' fill='#2F3783' />
      <path d='M14.789 23.0898C13.4417 23.2032 12.0927 23.3032 10.742 23.3899C12.094 23.3032 13.443 23.2032 14.789 23.0898Z' fill='#2F3783' />
      <path
        d='M24 12C24 9.62663 23.2962 7.30655 21.9776 5.33316C20.6591 3.35977 18.7849 1.8217 16.5922 0.913451C14.3995 0.00519943 11.9867 -0.232441 9.65892 0.230582C7.33115 0.693605 5.19295 1.83649 3.51472 3.51472C1.83649 5.19295 0.693605 7.33115 0.230582 9.65892C-0.232441 11.9867 0.00519943 14.3995 0.913451 16.5922C1.8217 18.7849 3.35977 20.6591 5.33316 21.9776C7.30655 23.2962 9.62663 24 12 24H12.211V14.656H9.63301V11.656H12.211V9.44001C12.1584 8.91619 12.2211 8.3872 12.3946 7.89016C12.568 7.39311 12.8482 6.94004 13.2153 6.56272C13.5824 6.18539 14.0277 5.89296 14.5198 5.70592C15.0119 5.51889 15.5389 5.44178 16.064 5.48001C16.8359 5.47728 17.6074 5.51667 18.375 5.59801V8.27801H16.8C15.556 8.27801 15.315 8.86901 15.315 9.73701V11.651H18.29L17.902 14.651H15.312V23.532C17.815 22.8122 20.0161 21.2981 21.5832 19.2179C23.1504 17.1378 23.9986 14.6044 24 12Z'
        fill={color}
      />
      <path d='M16.421 23.4302C13.7544 23.6022 11.08 23.7355 8.39801 23.8302C11.0813 23.7388 13.7557 23.6055 16.421 23.4302Z' fill='#2F3783' />
      <path d='M14.383 23.8359C12.969 23.8826 11.5523 23.9176 10.133 23.9409C11.551 23.9176 12.9677 23.8826 14.383 23.8359Z' fill='#2F3783' />
    </svg>
  );
};

export const InstagramIcon = ({ iconColor }: { iconColor?: string }) => {
  const color = iconColor ? iconColor : '#000000';

  return (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M14.297 12.0031C14.297 12.458 14.1621 12.9027 13.9094 13.2809C13.6567 13.6592 13.2975 13.954 12.8772 14.1281C12.4569 14.3021 11.9945 14.3477 11.5483 14.2589C11.1022 14.1702 10.6923 13.9511 10.3707 13.6295C10.049 13.3078 9.82996 12.898 9.74121 12.4518C9.65247 12.0057 9.69802 11.5432 9.8721 11.123C10.0462 10.7027 10.341 10.3435 10.7192 10.0907C11.0974 9.83802 11.5421 9.70313 11.997 9.70312C12.607 9.70312 13.192 9.94545 13.6234 10.3768C14.0547 10.8081 14.297 11.3931 14.297 12.0031Z'
        fill={color}
      />
      <path
        d='M17.372 7.93607C17.2573 7.63882 17.0817 7.36886 16.8564 7.14359C16.6312 6.91831 16.3612 6.74271 16.064 6.62807C15.6544 6.47637 15.2217 6.39621 14.785 6.39107C14.058 6.35807 13.84 6.35107 12.001 6.35107C10.162 6.35107 9.94298 6.35807 9.21698 6.39107C8.78022 6.39627 8.3476 6.47643 7.93797 6.62807C7.64076 6.74276 7.37084 6.91839 7.14557 7.14366C6.9203 7.36893 6.74467 7.63885 6.62997 7.93607C6.47819 8.34599 6.39802 8.77897 6.39297 9.21606C6.35997 9.94306 6.35297 10.1601 6.35297 12.0001C6.35297 13.8401 6.35997 14.0581 6.39297 14.7841C6.39812 15.2208 6.47828 15.6535 6.62997 16.0631C6.74461 16.3603 6.92022 16.6303 7.14549 16.8555C7.37077 17.0808 7.64072 17.2564 7.93797 17.3711C8.34787 17.523 8.78086 17.6031 9.21797 17.6081C9.94497 17.6411 10.162 17.6481 12.002 17.6481C13.842 17.6481 14.06 17.6411 14.786 17.6081C15.2231 17.6031 15.6561 17.523 16.066 17.3711C16.3632 17.2564 16.6332 17.0808 16.8584 16.8555C17.0837 16.6303 17.2593 16.3603 17.374 16.0631C17.5256 15.6534 17.6058 15.2208 17.611 14.7841C17.644 14.0571 17.651 13.8391 17.651 12.0001C17.651 10.1611 17.644 9.94206 17.611 9.21606C17.6054 8.77884 17.5246 8.34584 17.372 7.93607ZM12 15.5361C11.3002 15.5361 10.6162 15.3286 10.0344 14.9398C9.45254 14.551 8.99908 13.9985 8.73129 13.352C8.46351 12.7055 8.39344 11.9941 8.52995 11.3078C8.66647 10.6215 9.00343 9.99112 9.49823 9.49632C9.99303 9.00152 10.6234 8.66456 11.3097 8.52805C11.996 8.39153 12.7074 8.4616 13.3539 8.72939C14.0004 8.99717 14.553 9.45063 14.9417 10.0325C15.3305 10.6143 15.538 11.2983 15.538 11.9981C15.5384 12.4629 15.4471 12.9233 15.2695 13.3529C15.0919 13.7825 14.8314 14.1729 14.5028 14.5018C14.1742 14.8306 13.784 15.0915 13.3546 15.2695C12.9252 15.4475 12.4648 15.5391 12 15.5391V15.5361ZM15.678 9.14607C15.5144 9.14607 15.3545 9.09757 15.2185 9.0067C15.0825 8.91583 14.9765 8.78666 14.9139 8.63554C14.8513 8.48443 14.835 8.31815 14.8669 8.15773C14.8988 7.99731 14.9775 7.84994 15.0932 7.73428C15.2089 7.61863 15.3562 7.53988 15.5166 7.50797C15.6771 7.47606 15.8433 7.49243 15.9944 7.55502C16.1456 7.61762 16.2747 7.7236 16.3656 7.8596C16.4565 7.9956 16.505 8.1555 16.505 8.31906C16.5054 8.42783 16.4843 8.53561 16.443 8.63623C16.4017 8.73685 16.3409 8.82833 16.2642 8.90543C16.1874 8.98252 16.0963 9.04373 15.9958 9.08554C15.8954 9.12735 15.7877 9.14893 15.679 9.14906L15.678 9.14607Z'
        fill={color}
      />
      <path
        d='M12 0C9.62663 0 7.30655 0.703788 5.33316 2.02236C3.35977 3.34094 1.8217 5.21509 0.913451 7.4078C0.00519943 9.60051 -0.232441 12.0133 0.230582 14.3411C0.693605 16.6689 1.83649 18.8071 3.51472 20.4853C5.19295 22.1635 7.33115 23.3064 9.65892 23.7694C11.9867 24.2324 14.3995 23.9948 16.5922 23.0866C18.7849 22.1783 20.6591 20.6402 21.9776 18.6668C23.2962 16.6935 24 14.3734 24 12C24 8.8174 22.7357 5.76515 20.4853 3.51472C18.2348 1.26428 15.1826 0 12 0V0ZM18.849 14.841C18.8377 15.4128 18.7295 15.9784 18.529 16.514C18.352 16.9717 18.0813 17.3873 17.7343 17.7343C17.3873 18.0813 16.9717 18.352 16.514 18.529C15.9787 18.7293 15.4134 18.8375 14.842 18.849C14.107 18.883 13.872 18.891 12.001 18.891C10.13 18.891 9.89501 18.883 9.16001 18.849C8.5886 18.8375 8.02326 18.7293 7.48801 18.529C7.03032 18.352 6.61467 18.0813 6.26768 17.7343C5.92069 17.3873 5.65002 16.9717 5.47301 16.514C5.27257 15.9788 5.16437 15.4134 5.15301 14.842C5.11901 14.107 5.11101 13.872 5.11101 12.001C5.11101 10.13 5.11901 9.895 5.15301 9.16C5.16429 8.58825 5.27249 8.02256 5.47301 7.487C5.64984 7.02942 5.92021 6.61378 6.26683 6.26664C6.61345 5.91951 7.02869 5.64852 7.48601 5.471C8.02158 5.27056 8.58726 5.16236 9.15901 5.151C9.89401 5.117 10.129 5.109 12 5.109C13.871 5.109 14.106 5.117 14.841 5.151C15.4127 5.16238 15.9784 5.27058 16.514 5.471C16.9717 5.64807 17.3873 5.91876 17.7343 6.26574C18.0812 6.61272 18.3519 7.02835 18.529 7.486C18.7295 8.02155 18.8377 8.58725 18.849 9.159C18.883 9.894 18.89 10.129 18.89 12C18.89 13.871 18.883 14.106 18.849 14.841Z'
        fill={color}
      />
    </svg>
  );
};
export const TripadvisorIcon = ({ iconColor }: { iconColor?: string }) => {
  const color = iconColor ? iconColor : '#000000';

  return (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M16.504 11.3111C16.2151 11.3093 15.9321 11.3933 15.691 11.5526C15.4499 11.7118 15.2615 11.939 15.1497 12.2055C15.0379 12.4719 15.0077 12.7655 15.063 13.0491C15.1182 13.3328 15.2565 13.5936 15.4602 13.7985C15.6638 14.0035 15.9238 14.1433 16.207 14.2003C16.4903 14.2574 16.7841 14.229 17.0512 14.1188C17.3184 14.0087 17.5468 13.8217 17.7075 13.5816C17.8682 13.3414 17.954 13.059 17.954 12.7701C17.9527 12.3851 17.7998 12.0161 17.5284 11.743C17.257 11.4699 16.889 11.3147 16.504 11.3111V11.3111ZM16.504 13.5111C16.3574 13.5119 16.2138 13.4691 16.0915 13.3881C15.9692 13.3071 15.8737 13.1917 15.8172 13.0563C15.7607 12.921 15.7456 12.7719 15.774 12.6281C15.8023 12.4842 15.8728 12.3519 15.9764 12.2482C16.08 12.1444 16.2122 12.0738 16.356 12.0452C16.4999 12.0167 16.649 12.0315 16.7844 12.0879C16.9197 12.1442 17.0353 12.2395 17.1165 12.3617C17.1976 12.4839 17.2406 12.6274 17.24 12.7741C17.2392 12.9688 17.1614 13.1554 17.0234 13.2929C16.8855 13.4304 16.6988 13.5078 16.504 13.5081V13.5111Z'
        fill={color}
      />
      <path
        d='M7.49102 9.21095C6.77995 9.21253 6.08527 9.42466 5.49461 9.82058C4.90396 10.2165 4.44378 10.7785 4.17212 11.4356C3.90046 12.0927 3.8295 12.8156 3.96818 13.513C4.10685 14.2105 4.44896 14.8512 4.95135 15.3544C5.45374 15.8576 6.0939 16.2008 6.79109 16.3406C7.48828 16.4805 8.21127 16.4107 8.86885 16.1401C9.52644 15.8696 10.0892 15.4103 10.4861 14.8203C10.883 14.2303 11.0963 13.536 11.099 12.8249C11.1009 12.3503 11.0088 11.88 10.8283 11.4411C10.6477 11.0022 10.3821 10.6033 10.0467 10.2675C9.71142 9.93159 9.31299 9.66533 8.87438 9.48401C8.43577 9.30269 7.96563 9.20989 7.49102 9.21095V9.21095ZM7.54902 15.0019C7.10376 15.0233 6.66231 14.9109 6.28153 14.6791C5.90075 14.4473 5.5981 14.1068 5.41256 13.7015C5.22702 13.2962 5.16709 12.8446 5.24051 12.4049C5.31392 11.9652 5.51731 11.5576 5.82446 11.2346C6.13162 10.9115 6.52847 10.6878 6.96389 10.5923C7.39932 10.4968 7.85336 10.5339 8.26752 10.6988C8.68168 10.8636 9.03699 11.1487 9.28767 11.5173C9.53835 11.886 9.67291 12.3212 9.67402 12.7669C9.67295 13.3401 9.4519 13.891 9.05649 14.306C8.66108 14.7209 8.12148 14.9682 7.54902 14.9969V15.0019Z'
        fill={color}
      />
      <path
        d='M12 0C9.62663 0 7.30655 0.703788 5.33316 2.02236C3.35977 3.34094 1.8217 5.21509 0.913451 7.4078C0.00519943 9.60051 -0.232441 12.0133 0.230582 14.3411C0.693605 16.6689 1.83649 18.8071 3.51472 20.4853C5.19295 22.1635 7.33115 23.3064 9.65892 23.7694C11.9867 24.2324 14.3995 23.9948 16.5922 23.0866C18.7849 22.1783 20.6591 20.6402 21.9776 18.6668C23.2962 16.6935 24 14.3734 24 12C24 8.8174 22.7357 5.76516 20.4853 3.51472C18.2349 1.26428 15.1826 0 12 0V0ZM18.9 16.659C18.18 17.1151 17.3443 17.3549 16.492 17.35C16.1275 17.3512 15.7645 17.3048 15.412 17.212C14.5607 16.9986 13.7895 16.5429 13.192 15.9C13.111 15.814 13.035 15.725 12.95 15.628L11.983 17.069L11.032 15.648C11.01 15.659 11.004 15.661 11 15.664C10.9931 15.6701 10.9867 15.6768 10.981 15.684C10.276 16.5411 9.27848 17.1065 8.18101 17.271C7.55838 17.3709 6.9215 17.3351 6.31401 17.166C5.47177 16.9354 4.71412 16.4663 4.13221 15.8152C3.55031 15.1641 3.16894 14.3587 3.03401 13.496C2.93736 12.9008 2.96493 12.292 3.11501 11.708C3.25147 11.1596 3.48885 10.6415 3.81501 10.18C3.83848 10.1406 3.84566 10.0936 3.83501 10.049C3.69233 9.56623 3.4783 9.10749 3.20001 8.688C3.13101 8.58 3.04901 8.479 2.97401 8.375V8.338C2.98899 8.33896 3.00402 8.33896 3.01901 8.338C3.92701 8.338 4.83501 8.338 5.74301 8.338C5.7854 8.33645 5.82656 8.32331 5.86201 8.3C6.49894 7.89388 7.18083 7.56301 7.89401 7.314C8.40841 7.13267 8.93551 6.98962 9.47101 6.886C9.98919 6.78463 10.5132 6.71582 11.04 6.68C12.0418 6.61081 13.0482 6.65509 14.04 6.812C14.5437 6.88875 15.0406 7.00512 15.526 7.16C16.3742 7.41993 17.1848 7.78974 17.937 8.26C17.9929 8.29376 18.0567 8.31206 18.122 8.313C19.009 8.313 19.896 8.313 20.783 8.313C20.854 8.313 20.926 8.321 20.997 8.325C20.997 8.342 20.997 8.35 20.997 8.354L20.872 8.544C20.5623 8.99812 20.3229 9.4964 20.162 10.022C20.1514 10.0484 20.1476 10.0771 20.1509 10.1054C20.1543 10.1337 20.1646 10.1607 20.181 10.184C20.5414 10.6867 20.795 11.258 20.926 11.8625C21.0569 12.4671 21.0626 13.0921 20.9425 13.6989C20.8225 14.3057 20.5793 14.8814 20.228 15.3906C19.8767 15.8997 19.4247 16.3314 18.9 16.659V16.659Z'
        fill={color}
      />
      <path
        d='M7.42299 11.311C7.13483 11.314 6.854 11.4022 6.61593 11.5646C6.37785 11.727 6.19319 11.9562 6.08524 12.2234C5.97729 12.4906 5.95088 12.7838 6.00935 13.066C6.06781 13.3482 6.20854 13.6067 6.41376 13.809C6.61899 14.0113 6.87953 14.1483 7.16253 14.2027C7.44552 14.2571 7.73829 14.2265 8.0039 14.1148C8.26952 14.003 8.49608 13.8151 8.65503 13.5747C8.81397 13.3343 8.89816 13.0522 8.89699 12.764C8.89303 12.3763 8.7358 12.0058 8.45963 11.7336C8.18346 11.4613 7.81078 11.3094 7.42299 11.311V11.311ZM7.44099 13.516C7.24288 13.516 7.05287 13.4373 6.91278 13.2973C6.77269 13.1572 6.69399 12.9672 6.69399 12.769C6.69399 12.5709 6.77269 12.3809 6.91278 12.2408C7.05287 12.1007 7.24288 12.022 7.44099 12.022C7.63911 12.022 7.82911 12.1007 7.9692 12.2408C8.10929 12.3809 8.18799 12.5709 8.18799 12.769C8.18799 12.9672 8.10929 13.1572 7.9692 13.2973C7.82911 13.4373 7.63911 13.516 7.44099 13.516Z'
        fill={color}
      />
      <path
        d='M16.426 9.22503C15.7176 9.24097 15.0297 9.46558 14.4485 9.87072C13.8672 10.2759 13.4184 10.8435 13.1583 11.5026C12.8982 12.1616 12.8384 12.8828 12.9863 13.5757C13.1342 14.2686 13.4833 14.9025 13.9899 15.3979C14.4964 15.8933 15.1379 16.2282 15.8339 16.3606C16.5299 16.4931 17.2496 16.4172 17.9027 16.1425C18.5558 15.8679 19.1133 15.4065 19.5054 14.8164C19.8976 14.2263 20.1068 13.5336 20.107 12.825C20.1071 12.3454 20.0114 11.8705 19.8254 11.4284C19.6395 10.9863 19.367 10.5857 19.0241 10.2504C18.6812 9.91501 18.2747 9.65154 17.8285 9.47546C17.3824 9.29938 16.9055 9.21424 16.426 9.22503V9.22503ZM16.588 15.003C16.1434 15.021 15.7036 14.9056 15.325 14.6718C14.9465 14.438 14.6465 14.0963 14.4635 13.6907C14.2805 13.2852 14.2229 12.8342 14.2981 12.3956C14.3733 11.9571 14.5779 11.551 14.8855 11.2295C15.1932 10.9081 15.5899 10.6859 16.0247 10.5916C16.4596 10.4973 16.9127 10.535 17.3259 10.7001C17.7391 10.8651 18.0935 11.1499 18.3437 11.5178C18.5939 11.8858 18.7284 12.3201 18.73 12.765C18.731 13.3424 18.5086 13.8977 18.1093 14.3147C17.71 14.7317 17.1648 14.978 16.588 15.002V15.003Z'
        fill={color}
      />
      <path
        d='M13.438 9.48577C14.2129 8.7717 15.211 8.34773 16.263 8.28577C14.9943 7.73921 13.6284 7.45452 12.247 7.44877C10.6808 7.39567 9.12107 7.67409 7.66998 8.26577C8.73548 8.31692 9.75008 8.73679 10.5401 9.45352C11.3302 10.1702 11.8466 11.1393 12.001 12.1948C12.1546 11.1535 12.6621 10.1969 13.438 9.48577V9.48577Z'
        fill={color}
      />
    </svg>
  );
};
export const YoutubeIcon = ({ iconColor }: { iconColor?: string }) => {
  const color = iconColor ? iconColor : '#000000';

  return (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M10.505 14.248L14.405 12L10.505 9.75195V14.248Z' fill={color} />
      <path
        d='M12 0C9.62663 0 7.30655 0.703788 5.33316 2.02236C3.35977 3.34094 1.8217 5.21509 0.913451 7.4078C0.00519943 9.60051 -0.232441 12.0133 0.230582 14.3411C0.693605 16.6689 1.83649 18.8071 3.51472 20.4853C5.19295 22.1635 7.33115 23.3064 9.65892 23.7694C11.9867 24.2324 14.3995 23.9948 16.5922 23.0866C18.7849 22.1783 20.6591 20.6402 21.9776 18.6668C23.2962 16.6935 24 14.3734 24 12C24 8.8174 22.7357 5.76515 20.4853 3.51472C18.2348 1.26428 15.1826 0 12 0V0ZM19.5 12.012C19.5073 13.2212 19.4039 14.4286 19.191 15.619C19.1052 15.9356 18.938 16.2242 18.7061 16.4561C18.4742 16.688 18.1856 16.8552 17.869 16.941C15.9213 17.1701 13.9609 17.2733 12 17.25C10.039 17.274 8.07866 17.1667 6.13201 16.929C5.81543 16.8432 5.52684 16.676 5.29491 16.4441C5.06299 16.2122 4.89581 15.9236 4.81001 15.607C4.59629 14.4167 4.49252 13.2093 4.50001 12C4.4926 10.7908 4.59604 9.58337 4.80901 8.393C4.8965 8.07579 5.06417 7.78645 5.29588 7.55281C5.52759 7.31917 5.81553 7.14912 6.13201 7.059C8.07933 6.82997 10.0394 6.72676 12 6.75C13.961 6.72576 15.9214 6.833 17.868 7.071C18.1846 7.15681 18.4732 7.32398 18.7051 7.55591C18.937 7.78783 19.1042 8.07643 19.19 8.393C19.4099 9.5865 19.5137 10.7985 19.5 12.012Z'
        fill={color}
      />
    </svg>
  );
};

export const MapIcon = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='#8d99ae' className='w-10 h-10'>
      <path
        fillRule='evenodd'
        d='M8.161 2.58a1.875 1.875 0 011.678 0l4.993 2.498c.106.052.23.052.336 0l3.869-1.935A1.875 1.875 0 0121.75 4.82v12.485c0 .71-.401 1.36-1.037 1.677l-4.875 2.437a1.875 1.875 0 01-1.676 0l-4.994-2.497a.375.375 0 00-.336 0l-3.868 1.935A1.875 1.875 0 012.25 19.18V6.695c0-.71.401-1.36 1.036-1.677l4.875-2.437zM9 6a.75.75 0 01.75.75V15a.75.75 0 01-1.5 0V6.75A.75.75 0 019 6zm6.75 3a.75.75 0 00-1.5 0v8.25a.75.75 0 001.5 0V9z'
        clipRule='evenodd'
      />
    </svg>
  );
};

export const CloseIcon = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20' strokeWidth='1.5' stroke='currentColor' className='w-5 h-5'>
      <path strokeLinecap='round' strokeLinejoin='round' d='M6 18L18 6M6 6l12 12' />
    </svg>
  );
};

export const AddIcon = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' strokeWidth='2' stroke='white' className='w-[20px] h-[20px]'>
      <path strokeLinecap='round' strokeLinejoin='round' d='M12 4.5v15m7.5-7.5h-15' />
    </svg>
  );
};

export const ImageIcon = ({ width = 10, height = 10 }: { width?: number; height?: number }) => {
  return (
    <svg className={`w-${width} h-${height} text-gray-200 dark:text-gray-600`} aria-hidden='true' xmlns='http://www.w3.org/2000/svg' fill='currentColor' viewBox='0 0 20 18'>
      <path d='M18 0H2a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2Zm-5.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm4.376 10.481A1 1 0 0 1 16 15H4a1 1 0 0 1-.895-1.447l3.5-7A1 1 0 0 1 7.468 6a.965.965 0 0 1 .9.5l2.775 4.757 1.546-1.887a1 1 0 0 1 1.618.1l2.541 4a1 1 0 0 1 .028 1.011Z' />
    </svg>
  );
};

export const DeleteIcon = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' fill='white' viewBox='0 0 24 24' strokeWidth={1.5} stroke='currentColor' className='w-6 h-6'>
      <path strokeLinecap='round' strokeLinejoin='round' d='M9.75 9.75l4.5 4.5m0-4.5l-4.5 4.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z' />
    </svg>
  );
};

export const LeftArrow = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' strokeWidth={1.5} stroke='currentColor' className='w-5 h-5'>
      <path strokeLinecap='round' strokeLinejoin='round' d='M19.5 12h-15m0 0l6.75 6.75M4.5 12l6.75-6.75' />
    </svg>
  );
};

export const RightArrow = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' strokeWidth={1.5} stroke='currentColor' className='w-5 h-5'>
      <path strokeLinecap='round' strokeLinejoin='round' d='M4.5 12h15m0 0l-6.75-6.75M19.5 12l-6.75 6.75' />
    </svg>
  );
};

export const PackageInfoIcon = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' strokeWidth={1.5} stroke='currentColor' className='w-5 h-5'>
      <path strokeLinecap='round' strokeLinejoin='round' d='M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z' />
    </svg>
  );
};

export const PlusIcon = () => {
  return (
    <svg width='48' height='48' viewBox='0 0 48 48' fill='none' xmlns='http://www.w3.org/2000/svg' className='text-gray-600'>
      <circle cx='24' cy='24' r='23' stroke='currentColor' strokeWidth='2' fill='none' />
      <line x1='24' y1='16' x2='24' y2='32' stroke='currentColor' strokeWidth='2' />
      <line x1='16' y1='24' x2='32' y2='24' stroke='currentColor' strokeWidth='2' />
    </svg>
  );
};

export const CameraIcon = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='currentColor' className='w-6 h-6'>
      <path d='M6.827 6.175A2.31 2.31 0 015.186 7.23c-.38.054-.757.112-1.134.175C2.999 7.58 2.25 8.507 2.25 9.574V18a2.25 2.25 0 002.25 2.25h15A2.25 2.25 0 0021.75 18V9.574c0-1.067-.75-1.994-1.802-2.169a47.865 47.865 0 00-1.134-.175 2.31 2.31 0 01-1.64-1.055l-.822-1.316a2.192 2.192 0 00-1.736-1.039 48.774 48.774 0 00-5.232 0 2.192 2.192 0 00-1.736 1.039l-.821 1.316z' />
      <path d='M16.5 12.75a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zM18.75 10.5h.008v.008h-.008V10.5z' />
    </svg>
  );
};

export const PlayIcon = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='white' className='w-10 h-10'>
      <path fillRule='evenodd' d='M4.5 5.653c0-1.426 1.529-2.33 2.779-1.643l11.54 6.348c1.295.712 1.295 2.573 0 3.285L7.28 19.991c-1.25.687-2.779-.217-2.779-1.643V5.653z' clipRule='evenodd' />
    </svg>
  );
};

export const EventIcon = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' strokeWidth={1.5} stroke='currentColor' className='w-6 h-6'>
      <path
        strokeLinecap='round'
        strokeLinejoin='round'
        d='M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5m-9-6h.008v.008H12v-.008ZM12 15h.008v.008H12V15Zm0 2.25h.008v.008H12v-.008ZM9.75 15h.008v.008H9.75V15Zm0 2.25h.008v.008H9.75v-.008ZM7.5 15h.008v.008H7.5V15Zm0 2.25h.008v.008H7.5v-.008Zm6.75-4.5h.008v.008h-.008v-.008Zm0 2.25h.008v.008h-.008V15Zm0 2.25h.008v.008h-.008v-.008Zm2.25-4.5h.008v.008H16.5v-.008Zm0 2.25h.008v.008H16.5V15Z'
      />
    </svg>
  );
};

export const ProductIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      className='icon icon-tabler icon-tabler-glass-full'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      strokeWidth='2'
      stroke='currentColor'
      fill='none'
      strokeLinecap='round'
      strokeLinejoin='round'
    >
      <path stroke='none' d='M0 0h24v24H0z' fill='none' />
      <path d='M8 21l8 0' />
      <path d='M12 15l0 6' />
      <path d='M17 3l1 7c0 3.012 -2.686 5 -6 5s-6 -1.988 -6 -5l1 -7h10z' />
      <path d='M6 10a5 5 0 0 1 6 0a5 5 0 0 0 6 0' />
    </svg>
  );
};

export const PackageIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      className='icon icon-tabler icon-tabler-shopping-bag'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      strokeWidth='2'
      stroke='currentColor'
      fill='none'
      strokeLinecap='round'
      strokeLinejoin='round'
    >
      <path stroke='none' d='M0 0h24v24H0z' fill='none' />
      <path d='M6.331 8h11.339a2 2 0 0 1 1.977 2.304l-1.255 8.152a3 3 0 0 1 -2.966 2.544h-6.852a3 3 0 0 1 -2.965 -2.544l-1.255 -8.152a2 2 0 0 1 1.977 -2.304z' />
      <path d='M9 11v-5a3 3 0 0 1 6 0v5' />
    </svg>
  );
};

export const CustomIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      className='icon icon-tabler icon-tabler-question-mark'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      strokeWidth='2'
      stroke='currentColor'
      fill='none'
      strokeLinecap='round'
      strokeLinejoin='round'
    >
      <path stroke='none' d='M0 0h24v24H0z' fill='none' />
      <path d='M8 8a3.5 3 0 0 1 3.5 -3h1a3.5 3 0 0 1 3.5 3a3 3 0 0 1 -2 3a3 4 0 0 0 -2 4' />
      <path d='M12 19l0 .01' />
    </svg>
  );
};

export const PauseIcon = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' strokeWidth={1.5} stroke='currentColor' className='w-6 h-6'>
      <path strokeLinecap='round' strokeLinejoin='round' d='M15.75 5.25v13.5m-7.5-13.5v13.5' />
    </svg>
  );
};

export const CalendarIcon = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' strokeWidth={1.5} stroke='currentColor' className='w-5 h-5'>
      <path
        strokeLinecap='round'
        strokeLinejoin='round'
        d='M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5m-9-6h.008v.008H12v-.008ZM12 15h.008v.008H12V15Zm0 2.25h.008v.008H12v-.008ZM9.75 15h.008v.008H9.75V15Zm0 2.25h.008v.008H9.75v-.008ZM7.5 15h.008v.008H7.5V15Zm0 2.25h.008v.008H7.5v-.008Zm6.75-4.5h.008v.008h-.008v-.008Zm0 2.25h.008v.008h-.008V15Zm0 2.25h.008v.008h-.008v-.008Zm2.25-4.5h.008v.008H16.5v-.008Zm0 2.25h.008v.008H16.5V15Z'
      />
    </svg>
  );
};
